






























































import Vue from "vue";
import { mdiExitToApp, mdiCogOutline } from "@mdi/js";
import { StoreActions } from "@/structures/store";
import darkTheme from "@/mixins/darkTheme";
const Settings = () => import("@/components/dialogs/Settings.vue");
const ReleaseNotes = () => import("@/components/dialogs/ReleaseNotes.vue");
const KeyboardShortcuts = () =>
    import("@/components/dialogs/KeyboardShortcuts.vue");

export default Vue.extend({
    components: { Settings, ReleaseNotes, KeyboardShortcuts },
    mixins: [darkTheme],
    data() {
        return {
            settingsDialog: false,
            releaseNotesDialog: false,
            keyboardShortcutsDialog: false,
            trackChangeNotifications:
                localStorage.getItem("trackChangeNotifications") === "true",
            mdiExitToApp,
            mdiCogOutline,
        };
    },
    methods: {
        updateTrackChangeNotifications(): void {
            if (this.trackChangeNotifications) {
                localStorage.setItem("trackChangeNotifications", "false");
            } else {
                if (localStorage.getItem("trackChangeNotifications") !== null) {
                    localStorage.setItem("trackChangeNotifications", "true");
                } else {
                    switch (Notification.permission) {
                        case "granted":
                            localStorage.setItem(
                                "trackChangeNotifications",
                                "true"
                            );
                            break;
                        case "denied":
                            console.error(
                                "Notifications are disabled. Enable them, then enable track change notifications."
                            );
                            localStorage.setItem(
                                "trackChangeNotifications",
                                "false"
                            );
                            break;
                        case "default":
                            Notification.requestPermission();
                            localStorage.setItem(
                                "trackChangeNotifications",
                                "true"
                            );
                            break;
                    }
                }
            }

            this.trackChangeNotifications =
                localStorage.getItem("trackChangeNotifications") === "true";
        },
        logout(): void {
            this.$store.dispatch(StoreActions.CLEAR_CREDENTIALS);
            this.$router.push({ name: "Authorization" });
        },
    },
});
